<template>
  <div class="box box-info">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      <Dialog header="Pay Head" :visible.sync="displayBasic"
              :style="{width: '60vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'auto'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label >Pay head<span style="color:red">*</span></label>
            <InputText v-model.trim="name" id="name"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Account</label>
            <Dropdown v-model="accountId" :as="'label::value'" :options="accountMasterLists"
                      optionLabel="name" placeholder="Select Account"
                      :filter="true"
                      :showClear="true" id="account"/>
          </div>
          <div class="p-field p-col-12 p-md-8">
            <label>Tax Policies</label>
            <div class="p-field p-col-12 p-md-12">
              <Checkbox id="includeInTaxation" :binary="true" v-model="includeInTaxation"/>
              <label class="p-mr-2">Include In Taxation</label>
              <Checkbox id="retirementFund" :binary="true" v-model="retirementFund"/>
              <label class="p-mr-2">Retirement Fund</label>
              <Checkbox id="lumpSum" :binary="true" v-model="lumpSum"/>
              <label class="p-mr-2">Lump Sum(Yearly)</label>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Marital Status</label>
            <Dropdown v-model="maritalStatus"  id="maritalStatus" optionLabel="name"
                      placeholder="Select Marital Status" :options="maritalStatusList"/>
          </div>
          <div class="p-field p-col-12 p-md-8">
            <label>Tax Deduction Policies</label>
            <div class="p-field p-col-12 p-md-12">
              <Checkbox id="taxExempt" :binary="true" v-model="donated"/>
              <label class="p-mr-2">Donation To Tax Exempt Organization</label>
              <Checkbox id="lifeInsurance" :binary="true" v-model="hasLifeInsurance"/>
              <label>Life Insurance</label>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-4" >
            <label>Compute On</label>
            <Dropdown v-model="computeOn" id="computeOn" optionLabel="name" placeholder="Select PayHead"
                      :options="payHeadDropdownList"/>
          </div>
          <div class="p-field p-col-12 p-md-8">
            <label>PayHead Type</label>
            <div class="p-field p-col-12 p-md-8">
              <RadioButton id="earningFromEmployee" name="Earning" value="Earning" v-model="payHeadType"/>
              <label>Earning From Employee</label>
              <RadioButton id="deductionFromEmployee" name="Deduction" value="Deduction" v-model="payHeadType"/>
              <label>Deduction From Employee</label>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Amount Type</label>
            <Dropdown v-model="amountType" :options="amountTypeList"
                      optionLabel="key" placeholder="Select One"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Calculation Type</label>
            <div class="p-field p-col-12 p-md-6">
              <Dropdown v-model="calculationType" id="calculationType" optionLabel="name"
                        @change="addHrPayHeadDerivedDTO"
                        :options="calculationTypes"/>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Amount Predefined</label>
            <div class="p-field p-col-12 p-md-6">
              <Checkbox id="amountPredefined" v-model="amountPredefined" :binary="true"/>
            </div>
          </div>

          <div class="p-field p-col-12 p-md-12" v-if="calculationType.name === 'Derived'">
            <DataTable :value="hrPayheadDerivedConditionDTOList" editMode="cell"
                       class="p-datatable-responsive-demo p-datatable-gridlines editable-cells-table">
              <Column header="S.N" field="">
                <template #body="slotProps">
                  {{ slotProps.index + 1 }}
                </template>
              </Column>
              <Column header="Monthly Salary From" field="monthlyAmountFrom">
                <template #editor="slotProps">
                  <InputNumber id="withoutgrouping" v-model="slotProps.data[slotProps.column.field]" mode="decimal"
                               :useGrouping="false"/>
                </template>
              </Column>
              <Column header="Monthly Salary To" field="monthlyAmountTo">
                <template #editor="slotProps">
                  <InputNumber id="withoutgrouping" v-model="slotProps.data[slotProps.column.field]" mode="decimal"
                               :useGrouping="false"/>
                </template>
              </Column>
              <Column header="Amount Type" field="type">
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data['type']" :options="amountTypes" optionLabel="name"
                            optionValue="value" placeholder="Select a type">
                  </Dropdown>
                </template>
              </Column>
              <Column header="Value" field="value">
                <template #editor="slotProps">
                  <InputNumber id="locale-user" v-if="slotProps.data['type'] === 'Flat'"
                               v-model="slotProps.data[slotProps.column.field]"
                               mode="decimal" :minFractionDigits="2"/>
                  <InputNumber id="locale-user" v-if="slotProps.data['type'] === 'Percentage'"
                               v-model="slotProps.data[slotProps.column.field]"
                               mode="decimal" :minFractionDigits="2"/>
                </template>
              </Column>
              <Column header="Action">
                <template #body="slotProps">
                  <Button icon="pi pi-plus" class="p-button-raised p-button-success"
                          @click.prevent="addHrPayHeadDerivedDTO"/>
                  <Button icon="pi pi-times" class="p-button-danger"
                          @click.prevent="removeHrPayHeadDerivedDTO(slotProps.index)"/>
                </template>
              </Column>
            </DataTable>
            <div class="p-field p-col-12 p-md-4" v-if="calculationType.name === 'Derived'">
              <label>Compute On</label>
              <Dropdown v-model="computeOn" id="computeOn" optionLabel="name" placeholder="Select PayHead"
                        :options="payHeadDropdownList"/>
            </div>
<!--            {{computeOn}}-->
          </div>
        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="addPayHead"
                      :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New" @click.prevent="saveAndNewPayHead"/>
              <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
    </form>
    <DataTable :value="payHeadList" :paginator="true" :rows="10" :filters="filters"
               class="p-datatable-responsive-demo p-datatable-gridlines">
      <Column header="S.N" >
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Name" :sortable="true" field="name" filterMatchMode="contains">
        <template #filter>
          <InputText class="p-column-filter" v-model="filters['name']"/>
        </template>
      </Column>
      <Column header="Type" :sortable="true" field="payHeadType" filterMatchMode="contains">
        <template #filter>
          <InputText class="p-column-filter" v-model="filters['payHeadType']"/>
        </template>
      </Column>
      <Column header="Cal Type" :sortable="true" field="calculationType" filterMatchMode="contains">
        <template #filter>
          <InputText class="p-column-filter" v-model="filters['calculationType']"/>
        </template>
      </Column>
      <Column header="Marital Status" :sortable="true" field="maritalStatus" filterMatchMode="contains">
        <template #filter>
          <InputText class="p-column-filter" v-model="filters['maritalStatus']"/>
        </template>
      </Column>
      <Column header="Cr Account" :sortable="true" filterMatchMode="contains">
        <template #body="slotProps">
          {{slotProps.data.account.name}}
        </template>
<!--        <template #filter>-->
<!--          <InputText class="p-column-filter" v-model="filters[account.name]"/>-->
<!--        </template>-->
      </Column>


      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editPayHead(slotProps.data)"/>
          <!-- Edit button -->
          <!-- DeleteButton -->
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
        </template>
      </Column>
    </DataTable>
    <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deletePayHead"/>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import RadioButton from 'primevue/radiobutton'
import InputNumber from 'primevue/inputnumber'

export default {
  name: 'payHead',
  data() {
    return {
      displayBasic: false,
      name: '',
      loading: false,
      editing: false,
      payHeadId: null,
      deleteDialog: false,
      accountId: null,
      amountPredefined: false,
      includeInTaxation: false,
      retirementFund: false,
      // accountCrId: 0,
      lumpSum: false,
      maritalStatus: '',
      hasLifeInsurance: false,
      donated: false,
      filters: {},
      amountType: {},
      amountTypeList: [{key: 'Flat', value: 'Flat'}, {key: 'Percentage', value: 'Percentage'}],
      hrPayheadDerivedConditionDTOList: [],
      calculationType: {name: 'User Defined'},
      maritalStatusList: [{name: 'All'}, {name: 'Single'}, {name: 'Married'}],
      calculationTypes: [{name: 'User Defined'}, {name: 'Derived'}],
      amountTypes: [{name: 'Flat', value: 'Flat'}, {name: 'Percentage', value: 'Percentage'}],
      computeOn: null,
      payHeadType: '',
      obligatory: false
    }
  },
  computed: {
    payHeadList() {
      return this.$store.state.hr.payHeadList
    },
    payHeadDropdownList() {
      return this.$store.state.hr.payHeadDropdownList
    },
    accountMasterLists() {
      return this.$store.state.accountMaster.accountMasterLists
    }
  },
  mounted() {
    this.findPayHead()
    this.findAccountList()
    this.findPayHeadDropdown()
  },
  methods: {
    async findPayHead() {
      await this.$store.dispatch('loadHrPayHeadList')
    },
    async findPayHeadDropdown() {
      await this.$store.dispatch('loadHrPayHeadDropDownList')
    },
    async findAccountList() {
      await this.$store.dispatch('loadOfficeAccountListForDropdown')
    },
    async addPayHead() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      if (this.payHeadType === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please selcect PayHead type!', life: 3000})
        return
      }
      if (this.accountId === undefined) {
        this.accountId == null
        this.accountId = 0
      } else {
        this.accountId = this.accountId.id
      }
      let payHead = {
        id: this.payHeadId,
        name: this.name,
        payHeadType: this.payHeadType,
        calculationType: this.calculationType.name,
        maritalStatus: this.maritalStatus.name,
        amountPredefined: this.amountPredefined,
        retirementFund: this.retirementFund,
        lumpSum: this.lumpSum,
        includeInTaxation: this.includeInTaxation,
        donated: this.donated,
        hasLifeInsurance: this.hasLifeInsurance,
        gender: this.gender,
        amountType: this.amountType.value,
        obligatory: this.obligatory,
        accountId: this.accountId,
        computeOn: this.computeOn,
        hrPayheadDerivedConditionDTOList: this.hrPayheadDerivedConditionDTOList
      }
      // // debugger
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrPayHead', payHead)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrPayHead', payHead)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
      this.displayBasic = false
    },
    async saveAndNewPayHead() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      if (this.payHeadType === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please selcect PayHead type!', life: 3000})
        return
      }
      if (this.accountId === undefined) {
        this.accountId == null
        this.accountId = 0
      } else {
        this.accountId = this.accountId.id
      }
      let payHead = {
        id: this.payHeadId,
        name: this.name,
        payHeadType: this.payHeadType,
        calculationType: this.calculationType.name,
        maritalStatus: this.maritalStatus.name,
        amountPredefined: this.amountPredefined,
        retirementFund: this.retirementFund,
        lumpSum: this.lumpSum,
        includeInTaxation: this.includeInTaxation,
        donated: this.donated,
        hasLifeInsurance: this.hasLifeInsurance,
        gender: this.gender,
        obligatory: this.obligatory,
        accountId: this.accountId,
        amountType: this.amountType.value,
        computeOn: this.computeOn,
        hrPayheadDerivedConditionDTOList: this.hrPayheadDerivedConditionDTOList
      }
      let response = ''
      try {
        this.loading = true
        response = await this.$store.dispatch('createHrPayHead', payHead)
        this.loading = false
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    editPayHead(data) {
      this.editing = true
      this.payHeadId = data.id
      this.name = data.name
      this.payHeadType = data.payHeadType
      // this.calculationType = data.calculationType.name
      if (data.maritalStatus === 'Single') {
        this.maritalStatus = {name: 'Single'}
      } else if (data.maritalStatus === 'Married') {
        this.maritalStatus = {name: 'Married'}
      } else if (data.maritalStatus === 'All') {
        this.maritalStatus = {name: 'All'}
      }
      // this.maritalStatus = data.maritalStatus
      this.amountPredefined = data.amountPredefined
      this.retirementFund = data.retirementFund
      this.lumpSum = data.lumpSum
      this.includeInTaxation = data.includeInTaxation
      this.donated = data.donated
      this.hasLifeInsurance = data.hasLifeInsurance
      this.gender = data.gender
      this.obligatory = data.obligatory
      this.accountId = data.account
      this.computeOn = data.computeOn
      if (data.amountType === 'Flat') {
        this.amountType = {key: 'Flat', value: 'Flat'}
      } else if (data.amountType === 'Percentage') {
        this.amountType = {key: 'Percentage', value: 'Percentage'}
      } else {
        this.amountType = {key: '', value: ''}
      }
      this.hrPayheadDerivedConditionDTOList = data.hrPayheadDerivedConditionDTOList
      this.openBasic()
    },
    async deletePayHead(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let payHead = {
        id: this.payHeadId,
        deleteReason: value
      }
      try {
        let response = await this.$store.dispatch('deleteHrPayHead', payHead)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    addHrPayHeadDerivedDTO() {
      if (this.calculationType.name === 'Derived') {
        let hrPayHeadDerivedData = {
          monthlyAmountFrom: '',
          monthlyAmountTo: '',
          type: '',
          value: ''
        }
        this.hrPayheadDerivedConditionDTOList.push({...hrPayHeadDerivedData})
      }
    },
    removeHrPayHeadDerivedDTO(index) {
      if (this.hrPayheadDerivedConditionDTOList.length !== 1) {
        this.hrPayheadDerivedConditionDTOList.splice(index, 1)
      }
    },
    reset() {
      this.name = ''
      this.accountId = null
      this.includeInTaxation = false
      this.includeInTaxation = false
      this.lumpSum = false
      this.maritalStatus = ''
      this.hasLifeInsurance = false
      this.donated = false
      this.retirementFund = false
      this.payHeadType = ''
      this.amountPredefined = false
      this.calculationType = {name: 'User Defined'}
      this.computeOn = null
      this.amountType = {}
      this.hrPayheadDerivedConditionDTOList = []
    },
    openDeleteDialog(id) {
      this.payHeadId = id
      this.deleteDialog = true
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    cancel() {
      this.reset()
      this.displayBasic = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog,
    Dropdown,
    Checkbox,
    RadioButton,
    InputNumber
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// payHead.vue?bd74fd5e